var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      this.column.displayValue && this.column.displayValue !== null
        ? _c("span", { domProps: { innerHTML: _vm._s(_vm.displayValue) } })
        : _vm.value && _vm.titleColumn
        ? _vm._l(_vm.value, function(item, index) {
            return _c("span", { key: index, staticClass: "column" }, [
              _c("span", { staticClass: "text-primary" }, [
                _vm._v(_vm._s(_vm._f("relationLabel")(item, _vm.titleColumn)))
              ]),
              _vm.subtitleColumn
                ? _c("span", { staticClass: "text-grey-5 q-caption" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("relationLabel")(item, _vm.subtitleColumn)
                        ) +
                        "\n    "
                    )
                  ])
                : _vm._e()
            ])
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }